export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_05.588ff329.jpg";